// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"252":"c6940339","298":"ad8278f8","354":"7cec3fe5","362":"6872c36e","526":"c6940339","708":"6872c36e","791":"c6940339","794":"aba16c6d","961":"c6940339"}[chunkId] + ".chunk.css";
};